import Alpine from "alpinejs";
import AsyncAlpine from "async-alpine";
import mask from "@alpinejs/mask";
import intersect from "@alpinejs/intersect";
import persist from "@alpinejs/persist";
import focus from "@alpinejs/focus";
import collapse from "@alpinejs/collapse"; 
import { tns } from "tiny-slider/src/tiny-slider";

import "./magics";
import "./directives";

import "./modules/responsiveTables";
import "./modules/tooltip/tooltip";
import "./modules/track";

window.tns = tns;
window.Alpine = Alpine;
Alpine.plugin(intersect);
Alpine.plugin(mask);
Alpine.plugin(focus);
Alpine.plugin(persist);
Alpine.plugin(collapse);

document.addEventListener("alpine:initialized", () => {
  window.Alpine.isInitialized = true;
  if (document.querySelectorAll("lottie-player").length) import("@lottiefiles/lottie-player");
});

export { Alpine, AsyncAlpine };
